import ENDPOINTS from '../../constants/apiEndPoints';
import {axiosInstance} from '../axiosInstance';

export const handleCreateTextEntryService = async payload => {
  try {
    const response = await axiosInstance.post(
      ENDPOINTS.CREATE_TEXT_ENTRY,
      payload,
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errors?.join(`\n`) ||
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';

    // Pass the status and message up for UI to handle
    throw {status: error?.response?.status, message: errorMessage};
  }
};

export const handleGetAllTextEntryService = async (locale, search) => {
  try {
    const response = await axiosInstance.get(
      ENDPOINTS.GET_ALL_TEXT_ENTRIES(locale, search),
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errors?.join(`\n`) ||
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';

    // Pass the status and message up for UI to handle
    throw {status: error?.response?.status, message: errorMessage};
  }
};

export const handleUpdateTextEntryService = async (id, payload) => {
  try {
    const response = await axiosInstance.put(
      ENDPOINTS.GET_UPDATE_DELETE_TEXT_ENTRY(id),
      payload,
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errors?.join(`\n`) ||
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';

    // Pass the status and message up for UI to handle
    throw {status: error?.response?.status, message: errorMessage};
  }
};

export const handleDeleteTextEntryService = async id => {
  try {
    const response = await axiosInstance.delete(
      ENDPOINTS.GET_UPDATE_DELETE_TEXT_ENTRY(id),
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.errors?.join(`\n`) ||
      error?.response?.data?.message ||
      error?.message ||
      'Something went wrong';

    // Pass the status and message up for UI to handle
    throw {status: error?.response?.status, message: errorMessage};
  }
};
